/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentsPerUser
 */
export interface IncidentsPerUser {
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerUser
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof IncidentsPerUser
     */
    totalDriveSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof IncidentsPerUser
     */
    incidents: number;
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerUser
     */
    userFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerUser
     */
    userLastName: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerUser
     */
    shift?: string | null;
}

/**
 * Check if a given object implements the IncidentsPerUser interface.
 */
export function instanceOfIncidentsPerUser(value: object): value is IncidentsPerUser {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('totalDriveSeconds' in value) || value['totalDriveSeconds'] === undefined) return false;
    if (!('incidents' in value) || value['incidents'] === undefined) return false;
    if (!('userFirstName' in value) || value['userFirstName'] === undefined) return false;
    if (!('userLastName' in value) || value['userLastName'] === undefined) return false;
    return true;
}

export function IncidentsPerUserFromJSON(json: any): IncidentsPerUser {
    return IncidentsPerUserFromJSONTyped(json, false);
}

export function IncidentsPerUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentsPerUser {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'totalDriveSeconds': json['totalDriveSeconds'],
        'incidents': json['incidents'],
        'userFirstName': json['userFirstName'],
        'userLastName': json['userLastName'],
        'shift': json['shift'] == null ? undefined : json['shift'],
    };
}

export function IncidentsPerUserToJSON(json: any): IncidentsPerUser {
    return IncidentsPerUserToJSONTyped(json, false);
}

export function IncidentsPerUserToJSONTyped(value?: IncidentsPerUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'totalDriveSeconds': value['totalDriveSeconds'],
        'incidents': value['incidents'],
        'userFirstName': value['userFirstName'],
        'userLastName': value['userLastName'],
        'shift': value['shift'],
    };
}

